import { css } from 'styled-components';
// TODO: combine selectors SCSS style and check for used styles needed.
export const antdDatePicker = css`
  .ant-picker-content th {
    font-size: 12px;
    opacity: 0.5;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: -0.2px;
    color: ${({ theme }) => theme.baseBlue.a10};
    padding: 6px 0px;
  }

  .ant-picker-dropdown {
    font-family: 'Open Sans', sans-serif;
    font-size: 15px;
  }

  .ant-calendar-today-btn {
    color: ${({ theme }) => theme.baseBlue.a10} !important;
  }

  .ant-picker-cell .ant-picker-cell-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 12px;
    color: ${({ theme }) => theme.baseBlue.a10};
    border-radius: 0;

    &:hover {
      background: ${({ theme }) => theme.baseBlue.a9};
      color: ${({ theme }) => theme.white.a10};
    }

    &:active {
      color: ${({ theme }) => theme.white.a10};
      background: ${({ theme }) => theme.baseBlue.a9};
    }
  }

  .ant-picker-cell-disabled {
    color: #00000040;
  }

  .ant-picker-cell-disabled::before {
    background: rgba(0, 0, 0, .04);
  }

  .ant-picker-cell-today {
    .ant-picker-cell-inner {
      border: none;
      color: ${({ theme }) => theme.baseBlue.a10};

      &:hover {
        color: ${({ theme }) => theme.white.a10};
      }
    }
  }

  .ant-picker-panels {
    margin-top: 15px;
  }

  .ant-calendar-month-panel-year-select-content {
    background-color: ${({ theme }) => theme.black.a1};
    line-height: 1;
    padding: 5px 20px;
    border-radius: 5px;
  }

  .ant-picker-year-btn:hover,
  .ant-picker-month-btn:hover {
    color: ${({ theme }) => theme.white.a10} !important;
    font-weight: 400 !important;
  }

  .ant-calendar-month-panel-year-select-content:hover {
    background-color: ${({ theme }) => theme.baseBlue.a10};
    color: ${({ theme }) => theme.white.a10};
  }

  .ant-picker {
    width: 100%;
    font-family: 'Open Sans', sans-serif;
  }

  .ant-picker:hover .ant-picker-input:not(.ant-input-disabled) {
    border-color: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-picker:focus .ant-picker-input:not(.ant-input-disabled) {
    border-color: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-picker-range-wrapper {
    width: 100%;
    font-size: 15px;
  }

  .ant-calendar-input-wrap {
    display: none;
  }

  .ant-picker-header {
    border-bottom: none;
    height: 40px;
  }

  .ant-picker-header .ant-calendar-century-select,
  .ant-picker-header .ant-calendar-decade-select,
  .ant-picker-header .ant-picker-year-btn,
  .ant-picker-header .ant-picker-month-btn {
    color: inherit;
  }

  .ant-picker-header .ant-calendar-prev-century-btn,
  .ant-picker-header .ant-calendar-next-century-btn,
  .ant-picker-header .ant-calendar-prev-decade-btn,
  .ant-picker-header .ant-calendar-next-decade-btn,
  .ant-picker-header .ant-picker-header-prev-btn,
  .ant-picker-header .ant-picker-header-next-btn,
  .ant-picker-header .ant-picker-header-super-prev-btn,
  .ant-picker-header .ant-picker-header-super-next-btn {
    font-family: 'Open Sans', sans-serif;
  }

  .ant-picker-header-view {
    color: ${({ theme }) => theme.baseBlue.a10};
    margin: 5px 30px;
    background-color: ${({ theme }) => theme.baseBlue.a3};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-picker-header-view button:hover {
    color: ${({ theme }) => theme.white.a6};
  }

  .ant-picker-cell-selected .ant-picker-cell-inner {
    background: ${({ theme }) => theme.black.a1};
  }

  .ant-calendar-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-range-end .ant-picker-cell-inner,
  .ant-picker-cell-range-end .ant-picker-cell-inner {
    background: ${({ theme }) => theme.baseBlue.a10};
    color: ${({ theme }) => theme.white.a10};
  }

  .ant-calendar-cell-selected .ant-picker-cell-inner:hover,
  .ant-picker-cell-range-end .ant-picker-cell-inner:hover,
  .ant-picker-cell-range-end .ant-picker-cell-inner:hover {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-footer {
    border-top: none;
  }

  .ant-calendar .ant-calendar-ok-btn {
    background-color: ${({ theme }) => theme.baseBlue.a10};
    border-color: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar .ant-calendar-ok-btn:hover,
  .ant-calendar .ant-calendar-ok-btn:focus {
    background-color: ${({ theme }) => theme.baseBlue.a9};
    border-color: ${({ theme }) => theme.baseBlue.a0};
  }

  .ant-calendar .ant-calendar-ok-btn:active,
  .ant-calendar .ant-calendar-ok-btn.active {
    background-color: ${({ theme }) => theme.baseBlue.a10};
    border-color: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-time-picker-select li:hover {
    background: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-calendar-month-panel-header a:hover {
    color: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {
    display: flex;
    justify-content: center;
  }

  .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {
    font-family: 'Open Sans', sans-serif;
    line-height: 1;
  }

  .ant-calendar-month-panel-month {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-radius: 0;
  }

  .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-picker-header .ant-calendar-month-panel-month:hover {
    background: ${({ theme }) => theme.baseBlue.a9};
    color: ${({ theme }) => theme.white.a10};
  }

  .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-year-panel-header a:hover {
    color: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,
  .ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {
    font-family: 'Open Sans', sans-serif;
  }

  .ant-calendar-year-panel-year {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-radius: 0;
  }

  .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-picker-header .ant-calendar-year-panel-year:hover {
    background: ${({ theme }) => theme.baseBlue.a9};
    color: ${({ theme }) => theme.white.a10};
  }

  .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-decade-panel-header a:hover {
    color: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,
  .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {
    font-family: 'Open Sans', sans-serif;
  }

  .ant-calendar-decade-panel-decade:hover {
    background: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-week-number .ant-picker-body tr:hover {
    background: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-picker-range-wrapper .ant-picker-cell-in-range::before,
  .ant-picker-range-wrapper .ant-picker-cell-range-hover::before,
  .ant-picker-range-wrapper
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before {
    background: unset;
  }

  .ant-picker-cell-range-hover .ant-picker-cell-inner,
  .ant-picker-cell-in-range .ant-picker-cell-inner {
    background: ${({ theme }) => theme.baseBlue.a10};
  }

  .ant-calendar-week-number .ant-picker-body tr.ant-picker-cell-in-view {
    background: ${({ theme }) => theme.baseBlue.a9};
  }

  .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
  .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(
      .ant-picker-cell-range-end
    ):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end)
    .ant-picker-cell-inner {
    background: ${({ theme }) => theme.baseBlue.a9};
  }
`;
